import { IonContent } from '@ionic/react';
import { Button, ImageIcon } from '@shared/ui';
import { MAX_PHOTOS } from '@square-photo/stores/photo-converter';

export interface IdleScreenProps {
  onSelectPhotos: () => void;
}

/** 初始狀態的歡迎畫面，提供「選擇照片」入口。 */
export function IdleScreen({ onSelectPhotos }: IdleScreenProps) {
  return (
    /*
      標題已在工具列上，這裡不再重複一個 h1——同一句話出現兩次會讓人以為是兩個層級。
      主視覺因此由圖示與說明承擔，按鈕是唯一的焦點。
    */
    <IonContent>
      {/*
        1. **讓開安裝卡片**：卡片浮動、不佔版面高度，底部內距讀取它回報的
           `--install-prompt-inset`，卡片消失時歸零。
        2. **視覺置中而非幾何置中**：幾何正中央看起來偏低，底部的實心按鈕又把重心往下拉，
           故以兩個 flex 空白格（0.8 / 1.2）分配剩餘空間，比例不隨螢幕大小改變；
           `min-h-6` 保住小螢幕的最低留白。
      */}
      <div className="flex min-h-full flex-col items-center px-6 pb-[var(--install-prompt-inset,0px)] text-center">
        <div className="min-h-6 flex-[0.8]" aria-hidden="true" />
        <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-3xl bg-muted text-accent">
          <ImageIcon size={44} />
        </div>

        <p className="mb-8 max-w-xs text-sm leading-relaxed text-muted-foreground">
          選擇最多 {MAX_PHOTOS} 張照片，自動補白邊轉為 1:1
          方形，不上傳、不外流，處理完全在你的裝置進行。
        </p>

        <Button
          variant="primary"
          size="lg"
          fullWidth
          onClick={onSelectPhotos}
          className="max-w-xs"
        >
          選擇照片（最多 {MAX_PHOTOS} 張）
        </Button>

        <div className="min-h-6 flex-[1.2]" aria-hidden="true" />
      </div>
    </IonContent>
  );
}
